import React from 'react';
import IconButton from '@mui/material/IconButton';
import Row, { RowProps } from './Row';
import useCollapsibleRowService, { CollapsibleRowStorageProps } from './collapsibleRowService';
import ExpandLessIcon from '@mui/icons-material/ExpandLessOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMoreOutlined';
import { ShowData, ShowContextProvider } from 'framework/show';
import { Typography } from '@mui/material';

interface CollapsibleRowProps extends RowProps {
  children: Nullable<React.ReactElement | React.ReactElement[] | React.ReactNode>;
  toggleSource?: string;
  toggleProp?: string;
  level?: number;
  collapsibleRowStorageProps?: CollapsibleRowStorageProps;
}

const CollapsibleRow = ({
  children,
  template,
  toggleSource = 'id',
  toggleProp = 'source',
  level = 0,
  ...props
}: CollapsibleRowProps) => {
  const dataInstance = new ShowData(props.data);
  const { collapsed, handleToggleClick } = useCollapsibleRowService(props);

  return (
    <>
      <Row
        {...props}
        template={React.Children.map(template as any, (item: React.ReactElement) => {
          let toggle = null;

          if (!item) {
            return null;
          }

          if ((!children && !level) || item.props[toggleProp] !== toggleSource) {
            return item;
          }

          if (children) {
            toggle = (
              <IconButton
                type="button"
                onClick={handleToggleClick}
                size="small"
                sx={{ transform: 'translateX(-7px)', marginLeft: '-4px' }}
              >
                {collapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
              </IconButton>
            );
          }

          return (
            <Typography
              component="span"
              variant="inherit"
              sx={{
                '&&': {
                  paddingLeft: `${38 * level}px`,
                  display: 'flex',
                  alignItems: 'center',
                  font: 'inherit',
                  letterSpacing: 'inherit',
                },
              }}
            >
              {toggle}
              {item}
            </Typography>
          );
        })}
      />
      {collapsed ? null : (
        <ShowContextProvider
          value={{
            data: dataInstance,
          }}
        >
          {children}
        </ShowContextProvider>
      )}
    </>
  );
};

export default CollapsibleRow;
